import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableCellText from "ds/components/Table/Row/CellText";
import { ManagedUserGroupIntegration } from "types/generated";

const SlackTableSlackIdCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<ManagedUserGroupIntegration>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{integration.slackChannelID ?? "Unknown ID"}</TableCellText>
    </TableSimpleCell>
  );
};

export default SlackTableSlackIdCell;
